import ReactDOM from 'react-dom'
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getSubFormListStart, getSubFormListBySearchStart, removeSubFormByIdStart, resetStateModule, getSubFormModuleCreatedRecordsStart, getSubFormModuleGraphicalStatusStart, convertedSubformDataStart, getAllSubFormCustomViewStart, getSubFormKanbanListStart, updateSubFormCustomViewStart, updateCustomViewStatusStart, deleteCustomViewStart, resetFormSubModule } from "../../../Store/Slices/subFormSlice";
import { useDispatch, useSelector } from "react-redux";
import { Utils } from "../../../Utils";
import ImportModal from "../../../Components/ModalPopup/FormModules/ImportModal";
import Loader from "../../../Components/Loader";
import ConfirmationModal from "../../../Components/ModalPopup/ConfirmationModal";
import { Helpers } from "../../../Helpers";
import { HeaderImages } from "../../../Assets";
import ManageColumn from "../../../Components/ModalPopup/FormModules/ManageColumn";
import Charts from "../../../Components/Charts";
import { AgGridReact } from '@ag-grid-community/react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import Pagination from "../../../Components/formModules/Pagination";
import PreviewModal from "../../../Components/ModalPopup/FormModules/PreviewModal";
import { createTableColumnSubFormModuleStart, updateTableColumnSubFormModuleStart, destroyModuleLog, destroyCustomFormSubView } from "../../../Store/Slices/subFormSlice";
import { getItem } from "../../../Services/localService";
import PermissionDeniedModal from "../../../Components/PermissionDeniedModal";
import { Collapse } from 'react-bootstrap';
import CreateAssignment from "../../../Components/ModalPopup/FormModules/CreateAssignment";
import dayjs from "dayjs";
import OwnerChange from "../../../Components/ModalPopup/FormModules/OwnerChange";
import EmailComposer from "../../../Components/EmailComposer";
import NewWindowComponent from '../../../Components/NewWindowComponent';
import { getTemplateStart } from '../../../Store/Slices/templateSlice';
import PrintTemplate from '../../../Components/PrintTemplate';
import { ExportInvPdf, ExportQuotePdf, ExportSoPdf } from '../../../Components/ExportPdf'
import { toast } from 'react-toastify';
import Toast from '../../../Components/Toast';
import { LuClock3, LuLayoutList, LuPhoneCall } from "react-icons/lu";
import { FaRegEdit, FaRegFileAlt } from "react-icons/fa";
import { RiListView, RiTableView } from 'react-icons/ri';
import { BsFunnel, BsFunnelFill } from "react-icons/bs";
import { TbLayoutKanban } from 'react-icons/tb';
import { AiConformationModal } from '../../../Components/ModalPopup/AiConfirmationModal';
import AiResponse from '../../../Components/AiResponse';
// import { createResearchContentStart, getPromptStart, getResearchContentStart } from '../../../Store/Slices/promptSlice';
import { createResearchContentStart, getPromptStart, getResearchContentStart, getRedirectURIStart } from '../../../Store/Slices/promptSlice';
import ResearchContent from '../../../Components/ResearchContent';
import { FiMail, FiSearch } from "react-icons/fi";
import Emails from '../../../Components/ResearchContent/emails';

// Staic content Dummy images
import leadUser1 from '../../../Assets/images/leads/lead-user-1.png';
import leadUser2 from '../../../Assets/images/leads/lead-user-2.png';
import leadUser3 from '../../../Assets/images/leads/lead-user-3.png';
import leadUser4 from '../../../Assets/images/leads/lead-user-4.png';
import leadUser5 from '../../../Assets/images/leads/lead-user-5.png';
import leadUser6 from '../../../Assets/images/leads/lead-user-6.png';
import lead1 from '../../../Assets/images/leads/lead-1.png';
import lead2 from '../../../Assets/images/leads/lead-2.png';
import lead3 from '../../../Assets/images/leads/lead-3.png';
import lead4 from '../../../Assets/images/leads/lead-4.png';
import lead5 from '../../../Assets/images/leads/lead-5.png';
import lead6 from '../../../Assets/images/leads/lead-6.png';
import ComposeMail from '../../../Components/ResearchContent/composeMail';
import { MdOutlineMarkEmailUnread } from 'react-icons/md';
import { getModuleByIdStart } from '../../../Store/Slices/formSlice';
import { formatDateTime } from '../../../Components/DateFn';
import KanbanBoard from './KanbanBoard';
import { Check } from 'lucide-react';

ModuleRegistry.registerModules([ClientSideRowModelModule]);


const SubModule = () => {
    let defaultImg = "https://campussafetyconference.com/wp-content/uploads/2020/08/iStock-476085198.jpg";
    let getCreateUpdateListByID = useSelector((state) => state?.forms);
    let stageProbability = getCreateUpdateListByID?.modules?.[0]?.stageProbability;
    let promptData = useSelector((state) => state?.prompt);
    let templateData = useSelector((state) => state?.template)?.data;
    const getRedirectURI = useSelector((state) => state?.prompt?.message?.redirect_uri);
    let currentUserData = getItem('user');
    let currentUserEmail = currentUserData?.email;
    let basicPermissionData = getItem('modulePermission')?.basic;
    let formsubmodules = useSelector((state) => state?.subForm);
    let { id } = useParams();
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let [dynamicTableHeader, setDynamicTableHeader] = useState([]);
    let [allSubFormlayoutList, setAllSubFormlayoutList] = useState([]);
    let [subFormlayoutList, setSubFormlayoutList] = useState([]);
    let [openImportModal, setOpenImportModal] = useState(false);
    let [removeModalData, setRemoveModalData] = useState(null);
    let [showManageColumn, setShowManageColumn] = useState(null);
    let [columnDefs, setColumnDefs] = useState([]);
    let gridRef = useRef();
    let [showCharts, setShowCharts] = useState(false);
    let [currentPage, setCurrentPage] = useState(1);
    let [pageSize, setPageSize] = useState(10);
    let [selectedDays, setSelectedDays] = useState("Week");
    let [showFilter, setShowFilter] = useState(false);
    let [showPreviewModalId, setShowPreviewModalId] = useState(null);
    let [showExportModalId, setShowExportModalId] = useState(null);
    let [permissionDenied, setPermissionDenied] = useState(false);
    let [open, setOpen] = useState(localStorage.getItem("isChartOpen") === "true");
    let [selectedSubformId, setSeletedSubFormId] = useState(null);
    let formList = useSelector((state) => state?.forms);
    let [taskModuleData, setTaskModuleData] = useState(null);
    let [selectedFilterName, setSelectedFilterName] = useState(null);
    let [isTeam, setIsTeam] = useState(true);
    let [convertedData, setConvertedData] = useState([]);
    let [ownerChangeModal, setOwnerChangeModal] = useState(null);
    let [allCustomFormSubView, setAllcustomFormSubView] = useState([]);
    let [selectedCustomFormSubView, setSelectedCustomFormSubView] = useState(null);
    let [sendEmail, setSendEmail] = useState(false);
    let [selectedRowData, setSelectedRowData] = useState();
    let [selectedRowTableData, setSelectedRowTableData] = useState();
    let [showAiConfirmationModal, setShowAiConfirmationModal] = useState(false);
    let [isResponseGenerated, setIsResponseGenerated] = useState(false);
    let [showAiResponseModal, setShowAiResponseModal] = useState(false);
    let [selectedRowDataToGnerate, setSelectedRowDataToGnerate] = useState();
    let [isContentGenerated, setIsContentGenerated] = useState(false);
    let [isRegenerate, setIsRegenerate] = useState(false);
    let [isShowGenerateContent, setIsShowGenerateContent] = useState(false);
    let [selectedRowAiResponse, setSelectedRowAiResponse] = useState();
    let [selectedRowDataToReGnerate, setSelectedRowDataToReGnerate] = useState();
    let [showEmailModal, setShowEmailModal] = useState(false);
    let [selectedRowDataToViewMail, setSelectedRowDataToViewMail] = useState();
    let [rowAllData, setRowAllData] = useState(null);
    let [newTab, setnewTab] = useState(null);
    // mail compose
    let [showComposeEmailModal, setShowComposeEmailModal] = useState(false);
    const [canvasView, setCanvasView] = useState('table');
    const initialized = useRef(false);
    let [DealName, setDealName] = useState('');
    let [storeData, setStoreData] = useState({
        moduleId: id,
        data: []
    });
    let [showLoader, setShowLoader] = useState(false);
    let [option, setOption] = useState('');
    let [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    let [sortBy, setSortBy] = useState('');
    let [sortOrder, setSortOrder] = useState('');

    // useEffect(() => {
    //     dispatch(resetFormSubModule())
    // }, [])
    useEffect(() => {
        // debugger
        setShowLoader(true)
        if (id) {
            dispatch(getModuleByIdStart(id));
        }
        if (id?.length > 0) {
            dispatch(getAllSubFormCustomViewStart(id));
        }
        return () => {
            dispatch(destroyCustomFormSubView());
            setAllcustomFormSubView([]);
            setSelectedCustomFormSubView(null);
        }
    }, [id]);

    useEffect(() => {
        if (formsubmodules?.customViewUpdateStatus || formsubmodules?.customViewDeleteStatus) {
            dispatch(getAllSubFormCustomViewStart(id));
        }
    }, [formsubmodules?.customViewUpdateStatus, formsubmodules?.customViewDeleteStatus])

    useEffect(() => {
        if (id && formsubmodules?.modules?.name === 'Quotes' || formsubmodules?.modules?.name === 'Sales Orders' || formsubmodules?.modules?.name === 'Invoices') {
            dispatch(getTemplateStart(id));
        }
        if (formsubmodules?.modules?.name === 'Leads' || formsubmodules?.modules?.name === 'Accounts' || formsubmodules?.modules?.name === 'Prospects') {
            dispatch(getPromptStart())
            dispatch(getResearchContentStart(id))
        }

        if (formsubmodules?.modules?.name === 'Deals') {
            if (canvasView !== 'kanban' && formsubmodules?.modules?.name === 'Deals') {
                setCanvasView('kanban')
            } else {
                setCanvasView('table')
            }
        } else {
            setCanvasView('table')
        }
        // debugger
        setShowLoader(false)
    }, [formsubmodules?.modules?.name])

    useEffect(() => {
        if (selectedCustomFormSubView && formsubmodules?.isPagination) {
            dispatch(getSubFormListStart({ id }));
        }
    }, [selectedCustomFormSubView]);

    useEffect(() => {
        if (formsubmodules?.modules?.name === 'Leads') {
            if (formsubmodules?.customFormSubView?.length > 0) {
                setAllcustomFormSubView(formsubmodules?.customFormSubView);
                let defaultOpt = formsubmodules?.customFormSubView?.find(view => view.public_view === true && view.is_default === true);
                if (defaultOpt) {
                    setSelectedFilterName(defaultOpt?.custom_view_name);
                } else {
                    // setSelectedFilterName(`Open ${formsubmodules?.modules?.name}`);
                }
            }
            // } else {
            //     setSelectedFilterName(`Open ${formsubmodules?.modules?.name}`);
            // }
        }
    }, [formsubmodules?.customFormSubView, formsubmodules?.modules]);

    let getFormsubmodule = (formId) => {
        if (selectedFilterName === `Converted ${formsubmodules?.modules?.name}`) {
            return formsubmodules?.convertedData?.find(x => x?._id === formId);
        }
        return formsubmodules?.formsubmodules?.find(x => x?._id === formId);
    }

    useEffect(() => {
        if (!formsubmodules?.graphicalStatus && !formsubmodules?.isLoading) {
            setOpen(false);
        }
    }, [formsubmodules?.graphicalStatus]);

    useEffect(() => {
        if (formsubmodules?.modules?.name?.replaceAll(' ', '').toLowerCase() == 'articlemaster') {
            setShowCharts(true);
        } else {
            setShowCharts(false);
        }
        let subFormDatas = selectedCustomFormSubView ? Utils.filteredDataGet(formsubmodules.formsubmodules, selectedCustomFormSubView) : formsubmodules.formsubmodules;
        if (subFormDatas?.length > 0 && id) {
            let processedData = subFormDatas.map((item) => {
                return {
                    _id: item?._id,
                    ...[...item.data].reduce((acc, curr) => ({
                        ...acc,
                        ...curr.section_data
                    }), {}),
                    User_Name: item?.userId?.firstName ? (item?.userId?.firstName + ' ' + item?.userId?.lastName) : '_',
                    SAP_Status: (item.sapResponse?.sapStatus || '_'),
                    SAP_Message: (item.sapResponse?.sapMsg || '_'),
                    ...(formsubmodules?.workflowRules ? { Status: item.status || '_' } : {}),
                    createdAt: item.createdAt || '_',
                    updatedAt: item.updatedAt || '_',
                    createdBy: item.userId || '_',
                    updatedBy: item.updatedBy || '_'
                }
            });
            setSubFormlayoutList(processedData);
            setAllSubFormlayoutList(processedData);
        } else {
            setSubFormlayoutList([]);
            setAllSubFormlayoutList([]);
        }
        if (formsubmodules?.tableColumns?.data?.length > 0) {
            let tableColumns = formsubmodules.tableColumns.data || [];
            let staticColumns = [
                { label: "User Name", show: true, static: true },
                { label: "SAP Status", show: true, static: true },
                { label: "SAP Message", show: true, static: true }
            ];
            let staticStatusColumn = { label: "Status", show: true, static: true };
            let doesLabelExist = (label) => tableColumns.some(col => col.label === label);
            if (formsubmodules?.workflowRules && !doesLabelExist(staticStatusColumn.label)) {
                tableColumns = [staticStatusColumn, ...tableColumns];
            }
            if (formsubmodules?.sapStatus) {
                let filteredStaticColumns = staticColumns.filter(col => !doesLabelExist(col.label));
                tableColumns = [...filteredStaticColumns, ...tableColumns];
            }
            setDynamicTableHeader(tableColumns);
            setColumnData(tableColumns);

        } else {
            if (formsubmodules?.modules?._id && id) {
                let moduleStoreData = formsubmodules.modules?.fields;
                if (moduleStoreData) {
                    let fieldLabels = [
                        ...(formsubmodules?.sapStatus
                            ? [
                                { label: "User Name", show: true, static: true },
                                { label: "SAP Status", show: true, static: true },
                                { label: "SAP Message", show: true, static: true }
                            ]
                            : []
                        ),
                        ...(formsubmodules?.workflowRules ? [{ label: "Status", show: true, static: true }] : [])
                    ];
                    moduleStoreData?.sections.forEach(section => {
                        Object.entries(section?.dropped_list || {}).forEach(([key, value]) => {
                            value?.forEach(item => {
                                let label = item?.extra_fields?.field_label;
                                if (label && ([...Utils.stringInputTypes, ...Utils.numberInputTypes, ...Utils.dateInputTypes]?.includes(item?.input_type))) {
                                    fieldLabels.push({ label, show: true, static: false });
                                }
                            });
                        });
                    });
                    setDynamicTableHeader(fieldLabels);
                    setColumnData(fieldLabels);
                }
            } else {
                setDynamicTableHeader([]);
            }
        }
        if (formsubmodules?.modules?.name !== 'Leads') {
            //     if (!selectedFilterName?.includes('Converted')) {
            setSelectedFilterName(`Open ${formsubmodules?.modules?.name}`);
            //     }
        }
    }, [formsubmodules?.modules, formsubmodules?.tableColumns, formsubmodules?.formsubmodules, selectedCustomFormSubView, isContentGenerated, promptData.researchData]);

    useEffect(() => {
        if (formsubmodules?.modules?._id?.length > 0 && formsubmodules?.modules?.name === "Article Master") {
            dispatch(getSubFormModuleCreatedRecordsStart(id));
            dispatch(getSubFormModuleGraphicalStatusStart({
                moduleId: id,
                status: selectedDays
            }));
        }
    }, [formsubmodules?.modules?._id]);

    useEffect(() => {
        // initialized.current = true;
        if (formsubmodules?.modules?.name === "Deals" && (canvasView === 'table' || canvasView === 'canvas')) {
            if (id?.length > 0) {
                // dispatch(getAllSubFormCustomViewStart(id));
                // if (id?.length > 0) {
                dispatch(getSubFormListStart({ page: currentPage, count: pageSize, id, isActive: true }));
                // }
            }
        }
    }, [canvasView])

    let createAssignmentData = (id, name) => {
        if (formList?.navbarList?.length > 0) {
            setTaskModuleData(formList?.navbarList?.find(x => x?.name === name));
            setSeletedSubFormId(id);
        } else {
            setTaskModuleData(null);
            setSeletedSubFormId(null);
        }
    }

    // useEffect(() => {
    //     dispatch(getTemplateStart(id))
    // }, [])

    // const getDynamicContent = (content) => {
    //     if (formsubmodules?.modules?.name === 'Leads') {
    //         content = content.replaceAll('${Leads.Company}', selectedRowDataToGnerate?.Company);
    //     }
    //     if (formsubmodules?.modules?.name === 'Accounts') {
    //         content = content.replaceAll('${Leads.Company}', selectedRowDataToGnerate?.Account_Name);
    //     }
    //     content = content.replaceAll('${Company}', currentUserData?.organization?.organizationName);
    //     return content;
    // }
    const getDynamicContent = (content) => {
        if (formsubmodules?.modules?.name === 'Prospects') {
            content = content.replaceAll('${Leads.Company}', selectedRowDataToGnerate?.Company_Name);
        }
        if (formsubmodules?.modules?.name === 'Leads') {
            content = content.replaceAll('${Leads.Company}', selectedRowDataToGnerate?.Company);
        }
        if (formsubmodules?.modules?.name === 'Accounts') {
            content = content.replaceAll('${Leads.Company}', selectedRowDataToGnerate?.Account_Name);
        }
        content = content.replaceAll('${Company}', currentUserData?.organization?.organizationName);
        return content;
    }
    useEffect(() => {
        if (isResponseGenerated) {
            setIsShowGenerateContent(true)
            const headingsArr = promptData?.data?.[0]?.prompt_list
                .filter(item => item.is_include)
                .map(item => item.key);
            // let content = getDynamicContent(promptData?.data?.[0]?.generated_prompt)
            let aiPrompt = getDynamicContent(promptData?.data?.[0]?.generated_prompt)
            let researchPrompt = getDynamicContent(promptData?.data?.[0]?.assistant_prompt)
            let primaryEmail = rowAllData?.data?.find((section) => section.section_data?.table_data)?.section_data?.table_data?.find((row) => row.Email_isPrimary === true)?.Email;
            let payload = {
                "moduleId": id,
                "formModuleId": selectedRowDataToGnerate?._id,
                "home_company": currentUserData?.organization?.organizationName,
                // "customer_company": selectedRowDataToGnerate?.Company,
                "headings": headingsArr,
                "research_prompt": researchPrompt,
                "ai_prompt": aiPrompt,
                "to_email": primaryEmail || selectedRowDataToGnerate?.Email || ''
            }
            if (formsubmodules?.modules?.name === 'Prospects') {
                payload['customer_company'] = selectedRowDataToGnerate?.Company_Name
            }
            if (formsubmodules?.modules?.name === 'Leads') {
                payload['customer_company'] = selectedRowDataToGnerate?.Company
            }
            if (formsubmodules?.modules?.name === 'Accounts') {
                payload['customer_company'] = selectedRowDataToGnerate?.Account_Name
            }
            dispatch(createResearchContentStart(payload))
        }
    }, [isResponseGenerated])

    useEffect(() => {
        if (promptData.generateStatus) {
            if (id?.length > 0) {
                dispatch(getResearchContentStart(id))
            }
            setIsShowGenerateContent(false)
            setIsContentGenerated(true)
            setIsResponseGenerated(false)
        }
    }, [promptData.generateStatus])

    let [printExportModalTitle, setPrintExportModalTitle] = useState('');
    let [showPrintExportQuoteModal, setShowPrintExportQuoteModal] = useState(false)
    let [showPrintExportSoModal, setShowPrintExportSoModal] = useState(false)
    let [showPrintExportInvModal, setShowPrintExportInvModal] = useState(false)

    const handleShowQuotePreviewModal = () => {
        if (templateData?.length) {
            setShowPrintExportQuoteModal(true)
        } else {
            toast.error('No Templates Available', {
                autoClose: 2000,
            })
        }
    }

    const handleShowSOPreviewModal = () => {
        if (templateData?.length) {
            setShowPrintExportSoModal(true)
        } else {
            toast.error('No Templates Available', {
                autoClose: 2000,
            })
        }
    }

    const handleShowInvPreviewModal = () => {
        if (templateData?.length) {
            setShowPrintExportInvModal(true)
        } else {
            toast.error('No Templates Available', {
                autoClose: 2000,
            })
        }
    }

    const handlePrintPreview = (rowId, data) => {
        setShowExportModalId(rowId);
        handleShowQuotePreviewModal();
        setSelectedRowData(data)
        if (formsubmodules?.formsubmodules?.length) {
            const selectedObj = formsubmodules?.formsubmodules.find(item => item._id === rowId);
            const tableDetails = selectedObj?.tableDetails;
            setSelectedRowTableData(tableDetails)
        }
    }

    const handleSOPrintPreview = (rowId, data) => {
        setShowExportModalId(rowId);
        handleShowSOPreviewModal();
        setSelectedRowData(data)
        if (formsubmodules?.formsubmodules?.length) {
            const selectedObj = formsubmodules?.formsubmodules.find(item => item._id === rowId);
            const tableDetails = selectedObj?.tableDetails;
            setSelectedRowTableData(tableDetails)
        }
    }

    const handleInvPrintPreview = (rowId, data) => {
        setShowExportModalId(rowId);
        handleShowInvPreviewModal();
        setSelectedRowData(data)
        if (formsubmodules?.formsubmodules?.length) {
            const selectedObj = formsubmodules?.formsubmodules.find(item => item._id === rowId);
            const tableDetails = selectedObj?.tableDetails;
            setSelectedRowTableData(tableDetails)
        }
    }

    const handleDisplay = (data) => {
        if (formsubmodules?.modules?.name === 'Deals') {
            setDealName(data?.Stage)
        }
    }

    const setColumnData = (data) => {
        let formatData = (inputType, value) => {
            if (Array.isArray(value)) {
                return value?.map((item) => item?.name).join(", ");
            } else if (typeof value === "object" && value !== null) {
                return value?.name?.trim() || '';
            } else if (value && inputType?.input_type === "date" || value && inputType?.input_type === "datetime-local") {
                return dayjs(value).format("MMM D, YYYY hh:mm A");
            } else {
                return (typeof value === "string" ? value?.trim() : value) || "_";
            }
        }
        let columns = data?.filter(x => x.show)?.map((x) => ({
            headerName: x.label,
            field: Helpers.replaceData(x.label),
            valueGetter: (params) => {
                let headerName = params?.colDef?.headerName;
                let inputType = Utils.getParticularsModuleFields(formsubmodules?.modules?.fields?.sections, headerName);
                let value = params?.data[Helpers.replaceData(x.label)] || "";
                return formatData(inputType, value);
            },
            cellRenderer: (params) => {
                let headerName = params?.colDef?.headerName;
                let inputType = Utils.getParticularsModuleFields(formsubmodules?.modules?.fields?.sections, headerName);
                let value = params?.value === undefined ? "" : params?.value;

                // custom click for leads->lead name::start
                if ((formsubmodules?.modules?.name === "Leads" && headerName === "First Name") ||
                    (formsubmodules?.modules?.name === "Accounts" && headerName === "Account Name") ||
                    (formsubmodules?.modules?.name === "Contacts" && headerName === "First Name")) {
                    return (
                        <span
                            className="hover-link"
                            onClick={() => navigate(Utils.getNavigationUrl(`form-module/${formsubmodules?.modules?.name}/${params?.data?._id}`), {
                                state: {
                                    moduleName: formsubmodules?.modules?.name,
                                    card: params?.data,
                                    subFormData: formsubmodules,
                                    id: id,
                                    basicPermissionData: basicPermissionData
                                }
                            })}
                        >
                            {formatData(inputType, value)}
                        </span>
                    );
                }
                // ::end
                return formatData(inputType, value);
            },
            filter: true
        })) || [];

        columns.unshift({
            headerCheckboxSelection: true,
            checkboxSelection: true,
            filter: false,
            sortable: false,
            width: 50
        })

        if (formsubmodules?.modules?.name === 'Leads' || formsubmodules?.modules?.name === 'Accounts' || formsubmodules?.modules?.name === 'Prospects') {
            columns.unshift({
                width: 50,
                resizable: false,
                suppressMovable: true,
                filter: false,
                sortable: false,
                cellRenderer: (params) => {
                    const index = params.node.rowIndex;
                    let rowId = params.data?._id;
                    let data = promptData?.researchData?.filter((data) => data.formModuleId === rowId)
                    return (
                        <div>
                            {promptData?.researchData?.length === 0 ?
                                <>
                                    {/* <FaRegEdit /> */}
                                    <LuClock3 className="cursor-pointer" title="Generate Content" onClick={() => { setSelectedRowDataToGnerate(params.data); setShowAiConfirmationModal(true); setRowAllData(getFormsubmodule(rowId)); }} />
                                </> :
                                <>
                                    {data?.length ?
                                        <>
                                            <FaRegFileAlt className="cursor-pointer" title="View Generated Content" onClick={() => { setSelectedRowDataToReGnerate(params?.data); setSelectedRowAiResponse(data[0]); setShowAiResponseModal(true); setRowAllData(getFormsubmodule(rowId)); }} />
                                            {index === 0 ?
                                                <MdOutlineMarkEmailUnread style={{ height: '18px', width: '16px' }} className="cursor-pointer ms-2" title="View Mails" onClick={() => { setSelectedRowDataToViewMail(params.data); setShowEmailModal(true) }} /> :
                                                <>
                                                    {(formsubmodules?.modules?.name === 'Prospects' || formsubmodules?.modules?.name === 'Leads') &&
                                                        <FiMail className="cursor-pointer ms-2" title="View Mails" onClick={() => { setSelectedRowDataToViewMail(params.data); setShowEmailModal(true) }} />
                                                    }
                                                </>

                                            }
                                        </>
                                        : <>
                                            {/* <FaRegEdit className='cursor-pointer' onClick={() => setShowComposeEmailModal(true)} /> */}
                                            <LuClock3 className="cursor-pointer" title="Generate Content" onClick={() => { setSelectedRowDataToGnerate(params.data); setShowAiConfirmationModal(true); setRowAllData(getFormsubmodule(rowId)); dispatch(getRedirectURIStart({ id: currentUserEmail })) }} />
                                        </>
                                    }
                                </>
                            }
                            {/* {isContentGenerated ?
                                <FaRegFileAlt className="cursor-pointer" onClick={() => setShowAiResponseModal(true)} />
                                :
                                <LuClock3 className="cursor-pointer" onClick={() => { setSelectedRowDataToGnerate(params.data); setShowAiConfirmationModal(true) }} />
                            } */}
                        </div >
                    );
                },
                cellStyle: { "overflow": 'visible' }
            })
        }

        columns.unshift({
            width: 12,
            resizable: false,
            suppressMovable: true,
            filter: false,
            sortable: false,
            cellRenderer: (params) => {
                let rowId = params.data?._id;
                let dropdownId = `dropdownMenu-${rowId}`;
                return (
                    <div className="nested-dropdown dropdown">
                        <i className="fa fa-ellipsis-h cursor-pointer"
                            id={dropdownId}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        ></i>
                        <ul className="dropdown-menu end-unset p-0" aria-labelledby={dropdownId}>
                            <li>
                                <a className="dropdown-item"
                                    onClick={() => { setShowPreviewModalId(rowId); handleDisplay(params?.data) }}>
                                    Display
                                </a>
                            </li>
                            {
                                !params?.data?.converted && (
                                    <>
                                        <li>
                                            <a className="dropdown-item"
                                                onClick={() => {
                                                    dispatch(resetStateModule());
                                                    navigate(
                                                        Utils.getNavigationUrl(`form-module/sub-form/update/${id}/${rowId}`)
                                                    );
                                                }}
                                            >
                                                Edit
                                            </a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item"
                                                onClick={() =>
                                                    !basicPermissionData?.some(
                                                        (x) => x?.id === id && x.activities.delete === true
                                                    )
                                                        ? setPermissionDenied(true)
                                                        : rowId
                                                            ? setRemoveModalData({
                                                                subModuleId: rowId,
                                                                payload: {
                                                                    _id: rowId,
                                                                    moduleId: formsubmodules.modules._id
                                                                }
                                                            })
                                                            : console.error('rowId is undefined')
                                                }>
                                                Delete
                                            </a>
                                        </li>


                                        <li>
                                            <a className="dropdown-item" onClick={() => { setSendEmail(true); setSelectedRowData(params.data) }}>Send Email</a>
                                        </li>
                                        {formsubmodules?.modules?.name === 'Quotes' &&
                                            <>
                                                <li>
                                                    <a className="dropdown-item" onClick={() => { setPrintExportModalTitle('Print Preview'); handlePrintPreview(rowId, params.data) }}>Print Preview</a>
                                                </li>
                                                <li>
                                                    <a className="dropdown-item" onClick={() => { setPrintExportModalTitle('Export PDF'); handlePrintPreview(rowId, params.data) }}>Export to PDF</a>
                                                </li>
                                            </>
                                        }
                                        {formsubmodules?.modules?.name === 'Sales Orders' &&
                                            <>
                                                <li>
                                                    <a className="dropdown-item" onClick={() => { setPrintExportModalTitle('Print Preview'); handleSOPrintPreview(rowId, params.data) }}>Print Preview</a>
                                                </li>
                                                <li>
                                                    <a className="dropdown-item" onClick={() => { setPrintExportModalTitle('Export PDF'); handleSOPrintPreview(rowId, params.data) }}>Export to PDF</a>
                                                </li>
                                            </>
                                        }
                                        {formsubmodules?.modules?.name === 'Invoices' &&
                                            <>
                                                <li>
                                                    <a className="dropdown-item" onClick={() => { setPrintExportModalTitle('Print Preview'); handleInvPrintPreview(rowId, params.data) }}>Print Preview</a>
                                                </li>
                                                <li>
                                                    <a className="dropdown-item" onClick={() => { setPrintExportModalTitle('Export PDF'); handleInvPrintPreview(rowId, params.data) }}>Export to PDF</a>
                                                </li>
                                            </>
                                        }
                                        <li>
                                            <a className="dropdown-item" onClick={() => createAssignmentData(rowId, "Tasks")}>Create Task</a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" onClick={() => {
                                                setOwnerChangeModal(rowId)
                                            }}>Change Owner</a>
                                        </li>
                                        <li>
                                            <a className="dropdown-item" onClick={() => navigate(Utils.getNavigationUrl(`form-module/convert/${formsubmodules?.modules?._id}/${rowId}`))}>Convert</a>
                                        </li>
                                        <li className="nested-dropdown dropdown-submenu">
                                            <a className="dropdown-item dropdown-toggle">More...</a>
                                            <ul className="dropdown-menu">
                                                <li className="nested-dropdown dropdown-submenu p-0">
                                                    <a className="dropdown-item dropdown-toggle">Create Call</a>
                                                    <ul className="dropdown-menu">
                                                        <li className="p-0">
                                                            <a className="dropdown-item" onClick={() => createAssignmentData(rowId, "Calls")}>Schedule a call</a>
                                                        </li>
                                                        <li className="p-0">
                                                            <a className="dropdown-item" onClick={() => createAssignmentData(rowId, "Calls")}>Log a call</a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li className="p-0">
                                                    <a className="dropdown-item" onClick={() => createAssignmentData(rowId, "Meetings")}>Create Meeting</a>
                                                </li>
                                            </ul>
                                        </li>
                                    </>
                                )
                            }
                        </ul>
                    </div >

                );
            },
            cellStyle: { "overflow": 'visible' }
        });


        setColumnDefs(columns);
    }

    useEffect(() => {
        if (formsubmodules?.reload && id?.length > 0) {
            dispatch(getSubFormListStart({ page: currentPage, count: pageSize, id }));
            if (canvasView === 'kanban' && formsubmodules?.modules?.name === "Deals") {
                if (id) dispatch(getSubFormKanbanListStart({ id }));
            }
        }
    }, [formsubmodules?.reload]);

    const removeData = (subModuleId) => {
        dispatch(removeSubFormByIdStart(subModuleId));
    }

    const clickExportData = () => {
        const fileName = Helpers.replaceData(formsubmodules?.modules?.name);
        const sections = formsubmodules?.modules?.fields?.sections || [];

        if (!sections.length) {
            toast.error("No headers to export", { autoClose: 2000 });
            return;
        }

        let sectionHeaderRow = [];
        let fieldHeaderRow = [];

        const staticColumns = [
            ...(formsubmodules?.sapStatus
                ? [
                    { label: "User Name", section: "Static" },
                    { label: "SAP Status", section: "Static" },
                    { label: "SAP Message", section: "Static" },
                ]
                : []),
            ...(formsubmodules?.workflowRules
                ? [{ label: "Status", section: "Static" }]
                : []),
        ];

        staticColumns.forEach((col) => {
            sectionHeaderRow.push(col.section);
            fieldHeaderRow.push(col.label);
        });

        const sectionFields = {};

        sections.forEach((section) => {
            const sectionName = section.section_name || "Unnamed Section";

            if (!sectionFields[sectionName]) {
                sectionFields[sectionName] = [];
            }

            if (section.dropped_list && typeof section.dropped_list === 'object') {
                Object.values(section.dropped_list).forEach((area) => {
                    if (Array.isArray(area)) {
                        area.forEach((item) => {
                            const label = item?.extra_fields?.field_label;
                            const inputType = item?.input_type;

                            if (label && inputType && !['button', 'separator', 'spacer', 'html'].includes(inputType)) {
                                sectionFields[sectionName].push(label);
                            }
                        });
                    }
                });
            }


            if (section.selected_list && Array.isArray(section.selected_list)) {
                section.selected_list.forEach((item) => {
                    const label = item?.extra_fields?.field_label;
                    const inputType = item?.input_type;

                    if (label && inputType && !['button', 'separator', 'spacer', 'html'].includes(inputType)) {
                        sectionFields[sectionName].push(label);
                    }
                });
            }
        });

        Object.entries(sectionFields).forEach(([sectionName, fields]) => {
            if (fields.length > 0) {
                sectionHeaderRow.push(sectionName);
                fieldHeaderRow.push(...fields);

                for (let i = 1; i < fields.length; i++) {
                    sectionHeaderRow.push("");
                }
            }
        });

        const headers = [sectionHeaderRow, fieldHeaderRow];
        Utils.exportData(headers, fileName);
    };

    let onFilterTextBoxChanged = (event) => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            event.target.value,
        );
    }

    useEffect(() => {
        setSortBy('');
        setSortOrder('');
        const isActive = true;
        if (id?.length > 0) {
            dispatch(getSubFormListStart({ page: currentPage, count: pageSize, id, isActive }));
        }
    }, [id, currentPage, pageSize]);

    let handlePrevPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    let handleNextPage = () => {
        let totalPages = Math.ceil(formsubmodules?.totalCount / pageSize);
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    };

    let handlePageSizeChange = (size) => {
        setCurrentPage(1);
        setPageSize(size);
    };

    let changeDay = (val) => {
        if (val === selectedDays) return;
        dispatch(getSubFormModuleGraphicalStatusStart({
            moduleId: id,
            status: val
        }));
        setSelectedDays(val);
    }

    // const conditionOperators = {
    //     isnt: (a, b) => a !== b,
    //     contains: (a, b) => a?.includes(b),
    //     doesnt_contain: (a, b) => !a?.includes(b),
    //     starts_with: (a, b) => a?.startsWith(b),
    //     ends_with: (a, b) => a?.endsWith(b),
    //     is_empty: (a) => a === "" || a === null || a === undefined,
    //     isnt_empty: (a) => !(a === "" || a === null || a === undefined),
    // };

    // const checkCondition = (conditionName, value, compareValue) => {
    //     const fn = conditionOperators[conditionName];
    //     return fn ? fn(value, compareValue) : false;
    // };

    // const conditionOperators = {
    //     isnt: (a, b) => a !== b,
    //     contains: (a, b) => a?.toString()?.toLowerCase()?.includes(b?.toString()?.toLowerCase()),
    //     doesnt_contain: (a, b) => !a?.toString()?.toLowerCase()?.includes(b?.toString()?.toLowerCase()),
    //     starts_with: (a, b) => a?.toString()?.toLowerCase()?.startsWith(b?.toString()?.toLowerCase()),
    //     ends_with: (a, b) => a?.toString()?.toLowerCase()?.endsWith(b?.toString()?.toLowerCase()),
    //     is_empty: (a) => a === "" || a === null || a === undefined,
    //     isnt_empty: (a) => !(a === "" || a === null || a === undefined),
    // };

    const getValue = (v) => {
        if (v === null || v === undefined) return "";

        if (typeof v === "object") {
            return v?.name ?? "";
        }

        return v.toString();
    };

    const conditionOperators = {
        isnt: (a, b) => getValue(a) !== getValue(b),

        contains: (a, b) =>
            getValue(a).toLowerCase().includes(getValue(b).toLowerCase()),

        doesnt_contain: (a, b) =>
            !getValue(a).toLowerCase().includes(getValue(b).toLowerCase()),

        starts_with: (a, b) =>
            getValue(a).toLowerCase().startsWith(getValue(b).toLowerCase()),

        ends_with: (a, b) =>
            getValue(a).toLowerCase().endsWith(getValue(b).toLowerCase()),

        is_empty: (a) => getValue(a).trim() === "",
        isnt_empty: (a) => getValue(a).trim() !== ""
    };

    useEffect(() => {
        if (!allSubFormlayoutList?.length && formsubmodules?.modules?.name !== "Leads") return;
        let pickListData = Utils.getModuleFields(formsubmodules?.modules?.fields?.sections, ["select"]);
        let moduleName = formsubmodules?.modules?.name;
        let filteredList = [];
        switch (selectedFilterName) {
            case `Open ${moduleName}`:
                filteredList = isTeam
                    ? allSubFormlayoutList
                    : allSubFormlayoutList?.filter(x =>
                        Object.entries(x).some(([key, value]) =>
                            key.includes("Owner") && value?._id === currentUserData?._id
                        )
                    );
                let _selectedCustomFormSubView = allCustomFormSubView?.find(view => view.public_view === true && view.custom_view_name === `Open ${moduleName}`);

                if (_selectedCustomFormSubView?.criteria && _selectedCustomFormSubView?.criteria?.length > 0) {
                    _selectedCustomFormSubView?.criteria.forEach(criteria => {
                        const fieldKey = criteria?.field.split('#')[1].replace(/ /g, "_");
                        const condition = criteria?.condition;
                        const compareValue = criteria?.value;

                        const operatorFn = conditionOperators[condition];
                        if (!operatorFn) return;

                        filteredList = filteredList?.filter(item => {
                            const fieldValue = item[fieldKey];
                            return operatorFn(fieldValue, compareValue);
                        });

                    });
                }
                break;
            case "Junk Leads":
            case "Not Qualified Leads":
                let nameIs = selectedFilterName === "Junk Leads" ? "junk" : "not_qualified";
                filteredList = allSubFormlayoutList?.filter(x => {
                    let pick = pickListData?.moduleFields?.find(
                        y => y?.fields?.extra_fields?.field_label === "Lead Status"
                    );
                    let leadStatusMatches = pick?.fields?.extra_fields?.lead_status?.[
                        pick?.fields?.extra_fields?.options?.indexOf(x?.Lead_Status)
                    ] === nameIs;
                    if (isTeam) return leadStatusMatches;
                    let ownerMatches = Object.entries(x || {}).some(
                        ([key, value]) => key.includes("Owner") && value?._id === currentUserData?._id
                    );
                    return leadStatusMatches && ownerMatches;
                });

                let _selectedCustomFormSubViewJunk = allCustomFormSubView?.find(view => view.public_view === true && view.custom_view_name === selectedFilterName);
                if (_selectedCustomFormSubViewJunk?.criteria && _selectedCustomFormSubViewJunk?.criteria?.length > 0) {
                    _selectedCustomFormSubViewJunk?.criteria.forEach(criteria => {
                        const fieldKey = criteria?.field.split('#')[1].replace(/ /g, "_");
                        const condition = criteria?.condition;
                        const compareValue = criteria?.value;

                        const operatorFn = conditionOperators[condition];
                        if (!operatorFn) return;

                        filteredList = filteredList?.filter(item => {
                            const fieldValue = item[fieldKey];
                            return operatorFn(fieldValue, compareValue);
                        });

                    });
                }

                break;
            case `Converted ${moduleName}`:
                filteredList = isTeam
                    ? convertedData
                    : convertedData?.filter(x =>
                        Object.entries(x).some(([key, value]) =>
                            key.includes("Owner") && value?._id === currentUserData?._id
                        )
                    );
                let _selectedCustomFormSubViewConverted = allCustomFormSubView?.find(view => view.public_view === true && view.custom_view_name === `Converted ${moduleName}`);
                if (_selectedCustomFormSubViewConverted?.criteria && _selectedCustomFormSubViewConverted?.criteria?.length > 0) {
                    _selectedCustomFormSubViewConverted?.criteria.forEach(criteria => {
                        const fieldKey = criteria?.field.split('#')[1].replace(/ /g, "_");
                        const condition = criteria?.condition;
                        const compareValue = criteria?.value;

                        const operatorFn = conditionOperators[condition];
                        if (!operatorFn) return;

                        filteredList = filteredList?.filter(item => {
                            const fieldValue = item[fieldKey];
                            return operatorFn(fieldValue, compareValue);
                        });

                    });
                }

                break;

            default:
                break;
        }
        setSubFormlayoutList(filteredList);
    }, [allSubFormlayoutList, selectedFilterName, isTeam, convertedData]);


    useEffect(() => {
        if (selectedFilterName === `Converted ${formsubmodules?.modules?.name}`) {
            if (!formsubmodules?.convertedData?.length) {
                dispatch(convertedSubformDataStart(id));
            }
        }
    }, [selectedFilterName]);

    useEffect(() => {
        if (formsubmodules?.convertedData?.length > 0) {
            let processedData = formsubmodules?.convertedData.map((item) => {
                return {
                    _id: item?._id,
                    ...item.data.reduce((acc, curr) => ({
                        ...acc,
                        ...curr.section_data
                    }), {}),
                    User_Name: item?.userId?.firstName ? (item?.userId?.firstName + ' ' + item?.userId?.lastName) : '_',
                    SAP_Status: (item.sapResponse?.sapStatus || '_'),
                    SAP_Message: (item.sapResponse?.sapMsg || '_'),
                    Status: item.status || '_',
                    converted: true
                }
            });
            setConvertedData(processedData);
        }
    }, [formsubmodules?.convertedData]);



    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            dispatch(getSubFormListBySearchStart({ id, search: e?.target?.value }));
        }
    }

    const handleChange = (e) => {
        if (e.target.value === '') {
            dispatch(getSubFormListBySearchStart({ id, search: e?.target?.value }));
        }
    }

    const stageLookup = Object.fromEntries((stageProbability ?? []).map(s => [String(s.id), s.stageName]));
    const deals = subFormlayoutList ?? [];
    const transformedDeals = deals?.map(deal => ({
        ...deal,
        Stage: stageLookup[deal.Stage] || deal.Stage
    }));

    const handleSetDefault = (type) => {
        let rowId = allCustomFormSubView.filter((item) => item?.public_view === true && item?.custom_view_name === type).map((item) => item?._id)
        if (rowId?.length > 0) {
            dispatch(updateCustomViewStatusStart({
                id: rowId[0], payload: {
                    moduleId: id,
                    is_default: true
                }
            }))
        }
        // let moduleData = getCreateUpdateListByID?.modules?.[0]
        // if (moduleData) {
        //     let rowId = allCustomFormSubView.filter((item) => item?.public_view === true && item?.custom_view_name === type).map((item) => item?._id)
        //     let allData2 = Utils.getModuleFields(moduleData?.fields?.sections, ["text", "email", "tel", "select", "date", "datetime-local", "number", "currency", "decimal", "percent", "longinteger", "url", "lookup", "user"]);
        //     let updatedModuleFields = allData2.moduleFields.map(field => {
        //         return {
        //             label: field?.fields?.extra_fields?.field_label,
        //             show: true
        //         }
        //     });

        //     let sel_fields = allData2.moduleFields.map(field => {
        //         return {
        //             id: field?.fields?.id,
        //             label: field?.fields?.extra_fields?.field_label
        //         }
        //     });

        //     let sel_fields_data = allData2.moduleFields.map(field => {
        //         return field?.fields
        //     });
        //     let view = allCustomFormSubView?.find(view => view.public_view === true && view.custom_view_name === type)

        //     let obj = {
        //         moduleId: id,
        //         custom_view_data: {
        //             custom_view_name: type,
        //             criteria: view?.criteria,
        //             selected_fields: sel_fields,
        //             is_enable_criteria: true,
        //             selected_fields_data: sel_fields_data,
        //             public_view: true,
        //             is_default: true
        //         },
        //         manage_columns_data: updatedModuleFields
        //     }
        //     dispatch(updateSubFormCustomViewStart({ customViewId: rowId?.[0], payload: obj }))
        // }
    }

    const handleDeleteCustomView = (id) => {
        dispatch(deleteCustomViewStart(id))
    }

    const handleSortBy = (e) => {
        setSortBy(e.target.value);
        if (!sortOrder) {
            setSortOrder('asc')
        }
    }

    const handleSortOrder = (e) => {
        setSortOrder(e.target.value);
    }

    useEffect(() => {
        if (sortBy && sortOrder) {
            let payload = {
                id, sortBy, sortOrder, page: currentPage, count: pageSize,
            }
            dispatch(getSubFormKanbanListStart(payload));
        }
    }, [sortBy, sortOrder])

    // console.log('formsubmodules?.modules?.name', formsubmodules?.modules?.name);
    return (
        <>
            <Loader isVisible={showLoader || isShowGenerateContent || formsubmodules?.isLoading && !selectedSubformId || formsubmodules?.isCustomViewLoading || promptData?.isLoading} isShowGenerateContent={isShowGenerateContent} />
            <Toast />
            <div className="container-fluid">
                <div className="row">
                    <Collapse in={open}>
                        <div className="col-12  mt-3">
                            <div className="card text-end">
                                <div className="card-body p-0" id="collapseExample">
                                    <div className="row">
                                        {
                                            (showCharts && formsubmodules?.graphicalStatus) && <>
                                                <div className="col-md-4">
                                                    <div className="card rounded-4 shadow-sm">
                                                        <div className="card-body p-0">
                                                            <div className="card-title h6 fw-semibold d-flex align-items-center">
                                                                <span>Artical Master Status</span>
                                                                <div className="ms-auto">
                                                                    <div className="btn-group btn-group-sm">
                                                                        <button type="button" className="btn flat-btn dropdown-toggle rounded lh-sm" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <span>{selectedDays}</span> <i className="fa-solid fa-ellipsis"></i>
                                                                        </button>
                                                                        <ul className="dropdown-menu min-w-auto">
                                                                            <li><a className="dropdown-item cursor-pointer" onClick={() => changeDay("Day")}>Day</a></li>
                                                                            <li><a className="dropdown-item cursor-pointer" onClick={() => changeDay("Week")}>Week</a></li>
                                                                            <li><a className="dropdown-item cursor-pointer" onClick={() => changeDay("Month")}>Month</a></li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="article-donut-chart">
                                                                <Charts type='donut' series={[(formsubmodules?.graphicalStatus?.InApprovalCount || 0), (formsubmodules?.graphicalStatus?.SuccessCount || 0), (formsubmodules?.graphicalStatus?.FailCount || 0)]}
                                                                    options={{
                                                                        chart: {
                                                                            type: 'donut',
                                                                            height: '100%'
                                                                        },
                                                                        dataLabels: {
                                                                            enabled: false
                                                                        },

                                                                        responsive: [{
                                                                            breakpoint: 768,
                                                                            options: {
                                                                                chart: {
                                                                                    width: 300,
                                                                                    height: 200
                                                                                },
                                                                                legend: {
                                                                                    position: 'bottom',
                                                                                }
                                                                            }
                                                                        }],
                                                                        legend: {
                                                                            markers: {
                                                                                fillColors: ["#A4B0BE", "#29409d", "#29409d80"]
                                                                            }
                                                                        },
                                                                        labels: ["In Approval", "Success", "Error"],
                                                                        fill: {
                                                                            colors: ["#A4B0BE", "#29409d", "#29409d80"]
                                                                        }
                                                                    }} />
                                                                <div id="html-dist"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card rounded-4 shadow-sm h-100">
                                                        <div className="card-body p-0">
                                                            <div className="card-title h6 fw-semibold">Created Records</div>
                                                            <div className="progress-chart h-75 d-flex flex-column justify-content-around">
                                                                <div className="daily">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">Daily</span>
                                                                        <span className="count">{formsubmodules?.createdRecords?.todayCount}</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "75%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                                <div className="weekly">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">Weekly</span>
                                                                        <span className="count">{formsubmodules?.createdRecords?.oneWeekCount}</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "50%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                                <div className="monthly">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">Monthly</span>
                                                                        <span className="count">{formsubmodules?.createdRecords?.oneMonthCount}</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "62%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="62" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="card rounded-4 shadow-sm h-100">
                                                        <div className="card-body p-0">
                                                            <div className="card-title h6 fw-semibold">Material Type</div>
                                                            <div className="progress-chart h-75 d-flex flex-column justify-content-around">
                                                                <div className="daily">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">SW</span>
                                                                        <span className="count">456</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "75%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                                <div className="weekly">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">RF</span>
                                                                        <span className="count">456448</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "50%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                                <div className="monthly">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="label">RAW</span>
                                                                        <span className="count">200000</span>
                                                                    </div>
                                                                    <div className="progress" style={{ height: "6px" }}>
                                                                        <div className="progress-bar rounded-2" role="progressbar" aria-label="Example 1px high"
                                                                            style={{ width: "62%", backgroundColor: "#29409d" }}
                                                                            aria-valuenow="62" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                    <div className="col-md-12 pt-3">
                        <div className="card rounded-4 border-0 shadow-sm sub-form-module">
                            <div className="card-body p-0">
                                <div className="col-md-12 setup-actions d-flex pb-2 pt-0">
                                    <div className="me-3">
                                        <button className="btn btn-primary- px-2 btn-digy-dark" onClick={() => navigate(-1)}>
                                            <i className="fa fa-arrow-left me-2"></i> Back
                                        </button>
                                    </div>
                                    {canvasView !== 'kanban' &&
                                        <div className="left d-flex align-items-start">
                                            <div className="search-box border rounded-2- rounded-2">
                                                <button className="searchbutton bg-white" type="button"><FiSearch /></button>
                                                <input type="search" placeholder="Search" className="searchfield bg-white rounded-2"
                                                    // onInput={(e) => {
                                                    //     const search = e.target.value;
                                                    //     dispatch(getSubFormListBySearchStart({ id, search }));
                                                    // }}
                                                    onKeyDown={(e) => handleKeyDown(e)}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                            </div>
                                        </div>
                                    }
                                    <div className="ms-3">
                                        <div className="dropdown">
                                            <div className="btn-group btn-group-sm">
                                                <button type="button" className="btn btn-primary me-0 px-2 rounded-start btn-digy-dark"> {selectedCustomFormSubView?.custom_view_name || selectedFilterName} </button>
                                                <button type="button" className="btn btn-primary btn-digy-dark dropdown-toggle dropdown-toggle-split rounded-end pe-2" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i className="fa fa-caret-down"></i>
                                                    <span className="visually-hidden">Toggle Dropdown</span>
                                                </button>

                                                <ul className="dropdown-menu p-0 shadow" aria-labelledby="dropdownMenuButton1">
                                                    {allCustomFormSubView?.length > 0 && (
                                                        <>
                                                            <li className='p-2'><strong>Created By Me</strong></li>
                                                            {
                                                                allCustomFormSubView?.map((x, i) => !x?.public_view && (
                                                                    <li key={i} className="d-flex">
                                                                        <a className="dropdown-item py-2" role='button' onClick={() => setSelectedCustomFormSubView(x)}>{x?.custom_view_name}</a>
                                                                        <span className="m-1 me-3 cursor-pointer"
                                                                            // onClick={() => navigate(Utils.getNavigationUrl(`form-module/custom-view/${id}`), {
                                                                            //     state: {
                                                                            //         data: x
                                                                            //     }
                                                                            // })}

                                                                            onClick={(e) => {
                                                                                setOption(option === x?.custom_view_name ? '' : x?.custom_view_name);
                                                                                const rect = e.target.getBoundingClientRect();
                                                                                setMenuPosition({
                                                                                    top: rect.top + rect.height,
                                                                                    left: rect.left
                                                                                });
                                                                                e.stopPropagation();
                                                                            }}
                                                                        >...</span>

                                                                        <div className={`dropdown-menu ${option === x?.custom_view_name && 'show'}`}
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: i == 0 ? "13%" : `${i * 5}%`,
                                                                                left: "100%",
                                                                                transform: "translateY(-50%)",
                                                                                zIndex: 2000,
                                                                                // minWidth: "120px",
                                                                                boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)"
                                                                            }}
                                                                        >
                                                                            <button className="dropdown-item"
                                                                                onClick={() => {
                                                                                    // navigate(Utils.getNavigationUrl(`form-module/public-view/${id}`), {
                                                                                    //     state: {
                                                                                    //         allCustomFormSubView: allCustomFormSubView,
                                                                                    //         data: formsubmodules?.modules,
                                                                                    //         type: "Converted Leads"
                                                                                    //     }
                                                                                    // });
                                                                                    // onClick={() => 
                                                                                    navigate(Utils.getNavigationUrl(`form-module/custom-view/${id}`), {
                                                                                        state: {
                                                                                            data: x
                                                                                        }
                                                                                    });
                                                                                    // }
                                                                                    setOption(null);
                                                                                }}>Edit</button>
                                                                            <button className="dropdown-item"
                                                                                onClick={() => { { setOption(null); handleDeleteCustomView(x?._id) } }}
                                                                            >Delete</button>
                                                                            {/* <button className="dropdown-item"
                                                                                onClick={() => { handleSetDefault('Converted Leads'); setOption(null) }}
                                                                            >
                                                                                {allCustomFormSubView?.find(view => view.public_view === true && view.custom_view_name === "Converted Leads" && view?.is_default) ?
                                                                                    <span>Default <Check size={16} /></span>
                                                                                    :
                                                                                    <span>Set as Default</span>
                                                                                }
                                                                            </button> */}
                                                                        </div>
                                                                    </li>
                                                                ))
                                                            }
                                                        </>
                                                    )}
                                                    <li className='p-2'><strong>Public Views</strong></li>
                                                    <li className="d-flex"><a className="dropdown-item py-2 position-relative" role='button' onClick={() => {
                                                        setSelectedFilterName(`Open ${formsubmodules?.modules?.name}`);
                                                        setSelectedCustomFormSubView(null);
                                                    }}>Open {formsubmodules?.modules?.name}</a>
                                                        {formsubmodules?.modules?.name !== "Leads" ?
                                                            <span className="m-1 me-3 cursor-pointer" onClick={() => navigate(Utils.getNavigationUrl(`form-module/public-view/${id}`), {
                                                                state: {
                                                                    allCustomFormSubView: allCustomFormSubView,
                                                                    data: formsubmodules?.modules,
                                                                    type: "Open Leads"
                                                                }
                                                            })}>...</span> :
                                                            <>
                                                                <span className="m-1 me-3 cursor-pointer" onClick={(e) => {
                                                                    setOption(option === 'open' ? '' : 'open');
                                                                    e.stopPropagation();
                                                                }}>...</span>

                                                                <div className={`dropdown-menu ${option === 'open' && 'show'}`}
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "70%",
                                                                        left: "100%",
                                                                        transform: "translateY(-50%)",
                                                                        zIndex: 2000,
                                                                        // minWidth: "120px",
                                                                        boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)"
                                                                    }}
                                                                >
                                                                    <button className="dropdown-item"
                                                                        onClick={() => {
                                                                            navigate(Utils.getNavigationUrl(`form-module/public-view/${id}`), {
                                                                                state: {
                                                                                    allCustomFormSubView: allCustomFormSubView,
                                                                                    data: formsubmodules?.modules,
                                                                                    type: "Open Leads"
                                                                                }
                                                                            });
                                                                            setOption(null);
                                                                        }}>Edit</button>
                                                                    {/* <button className="dropdown-item"
                                                                        onClick={() => { setOption(null); }}
                                                                    >Delete</button> */}
                                                                    <button className="dropdown-item"
                                                                        onClick={() => { handleSetDefault('Open Leads'); setOption(null) }}
                                                                    >
                                                                        {allCustomFormSubView?.find(view => view.public_view === true && view.custom_view_name === "Open Leads" && view?.is_default) ?
                                                                            <span>Default <Check size={16} /></span>
                                                                            :
                                                                            <span>Set as Default</span>
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </>
                                                        }
                                                    </li>
                                                    {formsubmodules?.modules?.name === "Leads" && (
                                                        <>
                                                            <li className="d-flex align-items-center position-relative"><a className="dropdown-item py-2" role='button' onClick={() => {
                                                                setSelectedFilterName(`Converted ${formsubmodules?.modules?.name}`);
                                                                setSelectedCustomFormSubView(null);
                                                            }}>Converted {formsubmodules?.modules?.name}</a>
                                                                <span className="m-1 me-3 cursor-pointer" onClick={(e) => {
                                                                    setOption(option === 'converted' ? '' : 'converted');
                                                                    e.stopPropagation();
                                                                }}>...</span>

                                                                <div className={`dropdown-menu ${option === 'converted' && 'show'}`}
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        left: "100%",
                                                                        transform: "translateY(-50%)",
                                                                        zIndex: 2000,
                                                                        // minWidth: "120px",
                                                                        boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)"
                                                                    }}
                                                                >
                                                                    <button className="dropdown-item"
                                                                        onClick={() => {
                                                                            navigate(Utils.getNavigationUrl(`form-module/public-view/${id}`), {
                                                                                state: {
                                                                                    allCustomFormSubView: allCustomFormSubView,
                                                                                    data: formsubmodules?.modules,
                                                                                    type: "Converted Leads"
                                                                                }
                                                                            });
                                                                            setOption(null);
                                                                        }}>Edit</button>
                                                                    {/* <button className="dropdown-item"
                                                                        onClick={() => { setOption(null); }}
                                                                    >Delete</button> */}
                                                                    <button className="dropdown-item"
                                                                        onClick={() => { handleSetDefault('Converted Leads'); setOption(null) }}
                                                                    >
                                                                        {allCustomFormSubView?.find(view => view.public_view === true && view.custom_view_name === "Converted Leads" && view?.is_default) ?
                                                                            <span>Default <Check size={16} /></span>
                                                                            :
                                                                            <span>Set as Default</span>
                                                                        }
                                                                    </button>
                                                                </div>

                                                            </li>
                                                            <li className="d-flex"><a className="dropdown-item py-2 position-relative" role='button' onClick={() => {
                                                                setSelectedFilterName(`Junk Leads`);
                                                                setSelectedCustomFormSubView(null);
                                                            }}>Junk {formsubmodules?.modules?.name}</a>
                                                                <span className="m-1 me-3 cursor-pointer"
                                                                    // onClick={() => navigate(Utils.getNavigationUrl(`form-module/public-view/${id}`), {
                                                                    //     state: {
                                                                    //         allCustomFormSubView: allCustomFormSubView,
                                                                    //         data: formsubmodules?.modules,
                                                                    //         type: "Junk Leads"
                                                                    //     }
                                                                    // })}
                                                                    onClick={(e) => {
                                                                        setOption(option === 'junk' ? '' : 'junk');
                                                                        e.stopPropagation();
                                                                    }}
                                                                >...</span>

                                                                <div className={`dropdown-menu ${option === 'junk' && 'show'}`}
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "85%",
                                                                        left: "100%",
                                                                        transform: "translateY(-50%)",
                                                                        zIndex: 2000,
                                                                        // minWidth: "120px",
                                                                        boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)"
                                                                    }}
                                                                >
                                                                    <button className="dropdown-item"
                                                                        onClick={() => {
                                                                            navigate(Utils.getNavigationUrl(`form-module/public-view/${id}`), {
                                                                                state: {
                                                                                    allCustomFormSubView: allCustomFormSubView,
                                                                                    data: formsubmodules?.modules,
                                                                                    type: "Junk Leads"
                                                                                }
                                                                            });
                                                                            setOption(null);
                                                                        }}>Edit</button>
                                                                    {/* <button className="dropdown-item"
                                                                        onClick={() => { setOption(null); }}
                                                                    >Delete</button> */}
                                                                    <button className="dropdown-item"
                                                                        onClick={() => { handleSetDefault('Junk Leads'); setOption(null) }}
                                                                    >
                                                                        {allCustomFormSubView?.find(view => view.public_view === true && view.custom_view_name === "Junk Leads" && view?.is_default) ?
                                                                            <span>Default <Check size={16} /></span>
                                                                            :
                                                                            <span>Set as Default</span>
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </li>
                                                            <li className="d-flex"><a className="dropdown-item py-2 position-relative" role='button' onClick={() => {
                                                                setSelectedFilterName(`Not Qualified Leads`);
                                                                setSelectedCustomFormSubView(null);
                                                            }}>Not Qualified {formsubmodules?.modules?.name}</a>
                                                                <span className="m-1 me-3 cursor-pointer"
                                                                    // onClick={() => navigate(Utils.getNavigationUrl(`form-module/public-view/${id}`), {
                                                                    //     state: {
                                                                    //         allCustomFormSubView: allCustomFormSubView,
                                                                    //         data: formsubmodules?.modules,
                                                                    //         type: "Not Qualified Leads"
                                                                    //     }
                                                                    // })}
                                                                    onClick={(e) => {
                                                                        setOption(option === 'notqualified' ? '' : 'notqualified');
                                                                        e.stopPropagation();
                                                                    }}
                                                                >...</span>

                                                                <div className={`dropdown-menu ${option === 'notqualified' && 'show'}`}
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "95%",
                                                                        left: "100%",
                                                                        transform: "translateY(-50%)",
                                                                        zIndex: 2000,
                                                                        // minWidth: "120px",
                                                                        boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)"
                                                                    }}
                                                                >
                                                                    <button className="dropdown-item"
                                                                        onClick={() => {
                                                                            navigate(Utils.getNavigationUrl(`form-module/public-view/${id}`), {
                                                                                state: {
                                                                                    allCustomFormSubView: allCustomFormSubView,
                                                                                    data: formsubmodules?.modules,
                                                                                    type: "Not Qualified Leads"
                                                                                }
                                                                            });
                                                                            setOption(null);
                                                                        }}>Edit</button>
                                                                    {/* <button className="dropdown-item"
                                                                        onClick={() => { setOption(null); }}
                                                                    >Delete</button> */}
                                                                    <button className="dropdown-item"
                                                                        onClick={() => { handleSetDefault('Not Qualified Leads'); setOption(null) }}
                                                                    >
                                                                        {allCustomFormSubView?.find(view => view.public_view === true && view.custom_view_name === "Not Qualified Leads" && view?.is_default) ?
                                                                            <span>Default <Check size={16} /></span>
                                                                            :
                                                                            <span>Set as Default</span>
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        </>
                                                    )}
                                                    <li><a className="dropdown-item link-primary py-2" role='button'
                                                        onClick={() => navigate(Utils.getNavigationUrl(`form-module/custom-view/${id}`))}>
                                                        New Custom View</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ms-3">
                                        <div className="d-flex align-items-center">
                                            <span className="me-2">Self</span>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" checked={isTeam} onChange={(e) => setIsTeam(e.target.checked)} />
                                            </div>
                                            <span className="me-2">Team</span>
                                        </div>
                                    </div>
                                    <div className="ms-auto">
                                        <div className="btn-group btn-group-sm">
                                            <button className="btn px-2 rounded-2 btn-digy-dark-outline with-arrow dropdown-toggle" type="button" id="customViewDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                {/* <LuLayoutList className='mt-1 me-4' /> */}
                                                {canvasView === 'canvas' && <RiListView size={20} className='me-4' />}
                                                {canvasView === 'table' && <RiTableView size={20} className='me-4' />}
                                                {canvasView === 'kanban' && <TbLayoutKanban size={20} className='me-4' />}
                                            </button>
                                            <ul className="dropdown-menu p-0 shadow" aria-labelledby="customViewDropdown">
                                                <li>
                                                    <button className="btn btn-light border-0 justify-content-start dropdown-item py-2 cursor-pointer" onClick={() => setCanvasView('table')}>
                                                        <RiTableView size={20} /> <span className='ps-2'>Table View</span>
                                                    </button>
                                                </li>
                                                {/* || formsubmodules?.modules?.name === "Contacts" */}
                                                {(formsubmodules?.modules?.name === "Leads") && (
                                                    <li>
                                                        <button className="btn btn-light border-0 justify-content-start dropdown-item py-2 cursor-pointer" onClick={() => setCanvasView('canvas')}>
                                                            <RiListView size={20} /> <span className='ps-2'>Canvas View</span>
                                                        </button>
                                                    </li>
                                                )}
                                                {formsubmodules?.modules?.name === "Deals" && (
                                                    <li>
                                                        <button className="btn btn-light border-0 justify-content-start dropdown-item py-2 cursor-pointer" onClick={() => setCanvasView('kanban')}>
                                                            <TbLayoutKanban size={20} /> <span className='ps-2'>Kanban View</span>
                                                        </button>
                                                    </li>
                                                )}
                                            </ul>

                                            <button type="button" className="btn btn-primary me-2px- me-0 px-2 rounded-start btn-digy-dark" onClick={() => navigate(Utils.getNavigationUrl(`form-module/sub-form/create/${id}`))}
                                                disabled={!basicPermissionData?.some(x => x?.id === id && x.activities.create === true)}>
                                                <i className="fa fa-plus me-2"></i> Create {formsubmodules?.modules?.name}
                                            </button>
                                            <button type="button" className="btn btn-primary btn-digy-dark dropdown-toggle dropdown-toggle-split rounded-end pe-2" data-bs-toggle="dropdown" aria-expanded="false"
                                                disabled={!basicPermissionData?.some(x => x?.id === id && x.activities.create === true)}>
                                                <i className="fa fa-caret-down"></i>
                                                <span className="visually-hidden">Toggle Dropdown</span>
                                            </button>
                                            <button type="button" className={`btn border-0 px-2 rounded-2 ${showFilter ? 'text-digy-dark' : ''}`} onClick={() => setShowFilter(!showFilter)}>
                                                {/* ${showFilter ? 'btn-digy-dark' : 'btn-digy-dark-outline'}*/}
                                                {/* <i className="fa fa-filter"></i> */}
                                                {showFilter ? <BsFunnelFill size={24} /> : <BsFunnel size={24} />}
                                            </button>
                                            {(showCharts && formsubmodules?.graphicalStatus) && (
                                                <button type="button" className={`btn px-2 rounded-2 ${open ? 'btn-digy-dark' : 'btn-digy-dark-outline'}`} onClick={() => {
                                                    setOpen(!open);
                                                    localStorage.setItem("isChartOpen", !open);
                                                }} aria-controls="collapseExample">
                                                    <i className="fa fa-pie-chart"></i>
                                                </button>
                                            )}
                                            <ul className="dropdown-menu p-0 shadow">
                                                <li><a className="dropdown-item py-2 cursor-pointer" role='button' onClick={() => setOpenImportModal(true)}><i className="fa-solid fa-arrow-right-to-bracket me-2"></i> Import</a></li>
                                                {/* <hr className="dropdown-divider" /> */}
                                                <li><a className="dropdown-item py-2 cursor-pointer" role='button' onClick={clickExportData}><i className="fa-solid fa-arrow-right-to-bracket fa-rotate-180 me-2"></i> Export</a></li>
                                            </ul>

                                            <button className="nav-link p-0 dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src={HeaderImages.settingIcon} alt="setting-icon" width="25" height="25" />
                                            </button>
                                            <ul className="dropdown-menu p-0 shadow" aria-labelledby="dropdownMenuButton">
                                                <li><a className="dropdown-item py-2 cursor-pointer" role='button' onClick={() => setShowManageColumn(true)}>Manage Column</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    {canvasView === 'table' && (<>
                                        {/* height: showCharts && formsubmodules?.graphicalStatus ? 'calc(100vh - 45vh)' : 'calc(100vh - 17vh)' */}
                                        {columnDefs?.length > 0 && <div className={`ag-theme-quartz ${showCharts && formsubmodules?.graphicalStatus ? 'with-charts' : 'without-charts'}`} style={{ display: "flex", flexDirection: "column", position: "relative" }}>
                                            <AgGridReact
                                                ref={gridRef}
                                                rowData={transformedDeals || []}
                                                columnDefs={columnDefs}
                                                defaultColDef={{
                                                    filter: showFilter ? 'agTextColumnFilter' : showFilter,
                                                    floatingFilter: showFilter,
                                                }}
                                                onCellClicked={(e) => {
                                                    let columnId = e?.data?._id;
                                                    let clickedColumn = e.colDef.field;
                                                    if (!clickedColumn || !columnId) return;
                                                    setShowPreviewModalId(columnId);
                                                }}
                                                rowSelection="multiple"
                                                pagination={!formsubmodules?.isPagination}
                                                rowHeight={40}
                                                floatingFiltersHeight={40}
                                                headerHeight={40}
                                            />
                                            {formsubmodules?.isPagination && (
                                                <Pagination
                                                    currentPage={currentPage}
                                                    pageSize={pageSize}
                                                    totalCount={formsubmodules?.totalCount}
                                                    onPageSizeChange={handlePageSizeChange}
                                                    onPrevPage={handlePrevPage}
                                                    onNextPage={handleNextPage}
                                                />
                                            )}
                                        </div>}
                                    </>)}
                                    {canvasView === 'canvas1' && (<>
                                        <div className='list-view'>
                                            <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 180px)' }}>
                                                <table className='table mb-0'>
                                                    {/* <thead>
                                                        <tr>
                                                            <th style={{ width: "30px" }}>
                                                                <input className="form-check-input cursor-pointer" type="checkbox" />
                                                            </th>
                                                            <th>
                                                                <div className="row gx-2">
                                                                    <label className="col-auto col-form-label fw-normal" for="customViewSelect">Custom List Views:</label>
                                                                    <div className='col-auto'>
                                                                        <select className="form-select" id="customViewSelect">
                                                                            <option selected>Leads-Canvas</option>
                                                                            <option value="1">Option 1</option>
                                                                            <option value="2">Option 2</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div className="row gx-2 justify-content-end">
                                                                    <label className="col-auto col-form-label fw-normal">Sort By:</label>
                                                                    <div className='col-auto'>
                                                                        <select className="form-select" id="customViewSort1">
                                                                            <option selected>None</option>
                                                                            <option value="1">Option 1</option>
                                                                            <option value="2">Option 2</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className='col-auto'>
                                                                        <select className="form-select" id="customViewSort2">
                                                                            <option selected>Asc</option>
                                                                            <option value="1">Option 1</option>
                                                                            <option value="2">Option 2</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </thead> */}
                                                    <tbody>
                                                        {transformedDeals?.map((item, index) => (
                                                            <tr>
                                                                {/* <td style={{ width: "30px" }}>
                                                                    <input className="form-check-input cursor-pointer" type="checkbox" />
                                                                </td> */}
                                                                <td>
                                                                    <div className='hstack gap-3'>
                                                                        {/* <img src={leadUser1} alt='lead-user-img' width={60} height={60} /> */}
                                                                        <div>
                                                                            <div className='fw-medium'><span className='fs-6'>{item?.First_Name === "" || item?.Last_Name === "" ? "-" : item?.First_Name + ' ' + item?.Last_Name}</span>
                                                                                <span className='ps-2'>{item?.Lead_Status ?? '-'}</span>
                                                                            </div>
                                                                            {/* <div className='text-secondary'>Title Director of Sales | Company Jeo Printing</div> */}
                                                                            <div className='text-secondary'>{item?.Company_Name ?? '-'}</div>
                                                                            <div className='hstack'>
                                                                                <a href={`mailto:${item?.Email ?? '-'}`} className='link-primary'>{item?.Email ?? '-'}</a>
                                                                                <a href={`tel:${item?.Phone ?? '-'}`} className='link-primary hstack ps-2'>
                                                                                    <span>{item?.Phone ?? '-'}</span> {item?.Phone && <LuPhoneCall size={18} className='text-body-tertiary ms-2' />}
                                                                                </a>
                                                                            </div>
                                                                            {/* <div className='text-secondary'>Lead Source Cold Call  | Industry Service provider</div> */}
                                                                            <div className='text-secondary'>{item?.Lead_Source ?? '-'}</div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='hstack gap-2'>
                                                                        {/* <img src={lead1} alt='lead-img' width={40} height={40} /> */}
                                                                        <div>
                                                                            <div className='fw-medium fs-6'>{item?.Lead_Owner?.name ?? '-'}</div>
                                                                            <div className='text-secondary'>{item?.updatedAt ? formatDateTime(item?.updatedAt) : '-'}</div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {/* <tr>
                                                            <td style={{ width: "30px" }}>
                                                                <input className="form-check-input cursor-pointer" type="checkbox" />
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-3'>
                                                                    <img src={leadUser2} alt='lead-user-img' width={60} height={60} />
                                                                    <div>
                                                                        <div className='fw-medium'><span className='fs-6'>Alfonso George</span><span className='ps-2'>Cancelled</span></div>
                                                                        <div className='text-secondary'>Title Director of Sales | Company Jeo Printing</div>
                                                                        <div className='hstack'>
                                                                            <a href='mailto: kidman@digylax.com' className='link-primary'>kidman@digylax.com</a>
                                                                            <a href='tel: 1246 452 7534' className='link-primary hstack ps-2'>
                                                                                <span>1246 452 7534</span> <LuPhoneCall size={18} className='text-body-tertiary ms-2' />
                                                                            </a>
                                                                        </div>
                                                                        <div className='text-secondary'>Lead Source Cold Call  | Industry Service provider</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-2'>
                                                                    <img src={lead2} alt='lead-img' width={40} height={40} />
                                                                    <div>
                                                                        <div className='fw-medium fs-6'>Chance Vetrovs</div>
                                                                        <div className='text-secondary'>14/05/2025 10:33 PM</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "30px" }}>
                                                                <input className="form-check-input cursor-pointer" type="checkbox" />
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-3'>
                                                                    <img src={leadUser3} alt='lead-user-img' width={60} height={60} />
                                                                    <div>
                                                                        <div className='fw-medium'><span className='fs-6'>Davis Culhane</span><span className='ps-2'>Contact in future</span></div>
                                                                        <div className='text-secondary'>Title Director of Sales | Company Jeo Printing</div>
                                                                        <div className='hstack'>
                                                                            <a href='mailto: kidman@digylax.com' className='link-primary'>kidman@digylax.com</a>
                                                                            <a href='tel: 6543 724 6872' className='link-primary hstack ps-2'>
                                                                                <span>6543 724 6872</span> <LuPhoneCall size={18} className='text-body-tertiary ms-2' />
                                                                            </a>
                                                                        </div>
                                                                        <div className='text-secondary'>Lead Source Cold Call  | Industry Service provider</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-2'>
                                                                    <img src={lead3} alt='lead-img' width={40} height={40} />
                                                                    <div>
                                                                        <div className='fw-medium fs-6'>Brandon Levin</div>
                                                                        <div className='text-secondary'>14/05/2025 10:33 PM</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "30px" }}>
                                                                <input className="form-check-input cursor-pointer" type="checkbox" />
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-3'>
                                                                    <img src={leadUser4} alt='lead-user-img' width={60} height={60} />
                                                                    <div>
                                                                        <div className='fw-medium'><span className='fs-6'>Marcus Rosser</span><span className='ps-2'>Contact in future</span></div>
                                                                        <div className='text-secondary'>Title Director of Sales | Company Jeo Printing</div>
                                                                        <div className='hstack'>
                                                                            <a href='mailto: kidman@digylax.com' className='link-primary'>kidman@digylax.com</a>
                                                                            <a href='tel: 4235 321 5876' className='link-primary hstack ps-2'>
                                                                                <span>4235 321 5876</span> <LuPhoneCall size={18} className='text-body-tertiary ms-2' />
                                                                            </a>
                                                                        </div>
                                                                        <div className='text-secondary'>Lead Source Cold Call  | Industry Service provider</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-2'>
                                                                    <img src={lead4} alt='lead-img' width={40} height={40} />
                                                                    <div>
                                                                        <div className='fw-medium fs-6'>Zain Dokidis</div>
                                                                        <div className='text-secondary'>14/05/2025 10:33 PM</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "30px" }}>
                                                                <input className="form-check-input cursor-pointer" type="checkbox" />
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-3'>
                                                                    <img src={leadUser5} alt='lead-user-img' width={60} height={60} />
                                                                    <div>
                                                                        <div className='fw-medium'><span className='fs-6'>Carla Carder</span><span className='ps-2'>Lost Lead</span></div>
                                                                        <div className='text-secondary'>Title Director of Sales | Company Jeo Printing</div>
                                                                        <div className='hstack'>
                                                                            <a href='mailto: kidman@digylax.com' className='link-primary'>kidman@digylax.com</a>
                                                                            <a href='tel: 9634 465 4545' className='link-primary hstack ps-2'>
                                                                                <span>9634 465 4545</span> <LuPhoneCall size={18} className='text-body-tertiary ms-2' />
                                                                            </a>
                                                                        </div>
                                                                        <div className='text-secondary'>Lead Source Cold Call  | Industry Service provider</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-2'>
                                                                    <img src={lead5} alt='lead-img' width={40} height={40} />
                                                                    <div>
                                                                        <div className='fw-medium fs-6'>Davis Curtis</div>
                                                                        <div className='text-secondary'>14/05/2025 10:33 PM</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "30px" }}>
                                                                <input className="form-check-input cursor-pointer" type="checkbox" />
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-3'>
                                                                    <img src={leadUser6} alt='lead-user-img' width={60} height={60} />
                                                                    <div>
                                                                        <div className='fw-medium'><span className='fs-6'>Ann Korsgaard</span><span className='ps-2'>Cancelled</span></div>
                                                                        <div className='text-secondary'>Title Director of Sales | Company Jeo Printing</div>
                                                                        <div className='hstack'>
                                                                            <a href='mailto: kidman@digylax.com' className='link-primary'>kidman@digylax.com</a>
                                                                            <a href='tel: 554 45454 555' className='link-primary hstack ps-2'>
                                                                                <span>554 45454 555</span> <LuPhoneCall size={18} className='text-body-tertiary ms-2' />
                                                                            </a>
                                                                        </div>
                                                                        <div className='text-secondary'>Lead Source Cold Call  | Industry Service provider</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='hstack gap-2'>
                                                                    <img src={lead6} alt='lead-img' width={40} height={40} />
                                                                    <div>
                                                                        <div className='fw-medium fs-6'>Chance Philips</div>
                                                                        <div className='text-secondary'>14/05/2025 10:33 PM</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr> */}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {formsubmodules?.isPagination && (
                                                <Pagination
                                                    className="ag-theme-quartz"
                                                    currentPage={currentPage}
                                                    pageSize={pageSize}
                                                    totalCount={formsubmodules?.totalCount}
                                                    onPageSizeChange={handlePageSizeChange}
                                                    onPrevPage={handlePrevPage}
                                                    onNextPage={handleNextPage}
                                                />
                                            )}
                                            {/* <Pagination className="ag-theme-quartz"
                                                currentPage={currentPage}
                                                pageSize={pageSize}
                                                totalCount={'10'}
                                                onPageSizeChange={handlePageSizeChange}
                                                onPrevPage={handlePrevPage}
                                                onNextPage={handleNextPage}
                                            /> */}
                                        </div>
                                    </>)}
                                    {canvasView === 'canvas' && (<>
                                        <div className='list-view'>
                                            <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 180px)' }}>
                                                <table className='table mb-0'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "30px" }}>
                                                                {/* <input className="form-check-input cursor-pointer" type="checkbox" /> */}
                                                            </th>
                                                            <th>
                                                                <div className="row gx-2">
                                                                    {/* <label className="col-auto col-form-label fw-normal" for="customViewSelect">Custom List Views:</label>
                                                                    <div className='col-auto'>
                                                                        <select className="form-select" id="customViewSelect">
                                                                            <option selected>Leads-Canvas</option>
                                                                            <option value="1">Option 1</option>
                                                                            <option value="2">Option 2</option>
                                                                        </select>
                                                                    </div> */}
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div className="row gx-2 justify-content-end">
                                                                    <label className="col-auto col-form-label fw-normal">Sort By:</label>
                                                                    <div className='col-auto'>
                                                                        <select className="form-select" id="customViewSort1"
                                                                            onChange={(e) => handleSortBy(e)}
                                                                            value={sortBy}>
                                                                            <option value="" disabled selected>None</option>
                                                                            {transformedDeals?.length > 0 && Object.keys(transformedDeals?.[0])?.map((item) => item !== "_id" && (
                                                                                <option key={item} value={item}>{item.replace(/_/g, " ")}</option>
                                                                            ))}
                                                                            {/* <option value="Deal_Owner">Deal Owner</option>
                                                                            <option value="Account_Name">Account Name</option>
                                                                            <option value="Type">Type</option>
                                                                            <option value="Lead_Source">Lead Source</option>
                                                                            <option value="Deal_Name">Deal Name</option>
                                                                            <option value="Closing_Date">Closing Date</option>
                                                                            <option value="Probability_">Probability</option>
                                                                            <option value="Contact_Name">Contact Name</option>
                                                                            <option value="Amount">Amount</option>
                                                                            <option value="Stage">Stage</option>
                                                                            <option value="Expected_Revenue">Expected Revenue</option> */}
                                                                        </select>
                                                                    </div>
                                                                    <div className='col-auto'>
                                                                        <select className="form-select" id="customViewSort2"
                                                                            onChange={(e) => handleSortOrder(e)}
                                                                            value={sortOrder}>
                                                                            <option value="" disabled selected>None</option>
                                                                            <option value="asc">Asc</option>
                                                                            <option value="desc">Desc</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {transformedDeals?.length > 0 && transformedDeals?.map((item, index) => (
                                                            <tr>
                                                                <td style={{ width: "30px" }}>
                                                                    {/* <input className="form-check-input cursor-pointer" type="checkbox" /> */}
                                                                </td>
                                                                <td>
                                                                    <div className='hstack gap-3'>
                                                                        <img src={item?.Profile_Picture ?? defaultImg}
                                                                            alt='lead-user-img' width={60} height={60}
                                                                            style={{ opacity: item?.Profile_Picture ? 1 : 0.3 }}
                                                                            className="rounded-circle"
                                                                        />
                                                                        <div>
                                                                            <div className='fw-medium'><span className='fs-6'>{item?.First_Name + ' ' + item?.Last_Name}</span><span className='ps-2'>{item?.Lead_Status ?? '-'}</span></div>
                                                                            <div className='text-secondary'>Company {item?.Company_Name ?? '-'}</div>
                                                                            <div className='hstack'>
                                                                                <a href={`mailto:${item?.Email ?? '-'}`} className='link-primary'>{item?.Email ?? '-'}</a>
                                                                                {item?.Phone &&
                                                                                    <a href={`tel:${item?.Phone ?? '-'}`} className='link-primary hstack ps-2'>
                                                                                        <span>{item?.Phone ?? '-'}</span> <LuPhoneCall size={18} className='text-body-tertiary ms-2' />
                                                                                    </a>
                                                                                }
                                                                                {item?.Mobile &&
                                                                                    <a href={`tel:${item?.Mobile ?? '-'}`} className='link-primary hstack ps-2'>
                                                                                        <span>{item?.Mobile ?? '-'}</span> <LuPhoneCall size={18} className='text-body-tertiary ms-2' />
                                                                                    </a>
                                                                                }
                                                                            </div>
                                                                            <div className='text-secondary'>Lead Source {item?.Lead_Source ?? '-'}  | Industry {item?.Industry ?? '-'}</div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='hstack gap-2'>
                                                                        <img src={item?.createdBy?.profilePicture ? item?.createdBy?.profilePicture : defaultImg} alt='lead-img' width={40} height={40}
                                                                            style={{
                                                                                borderRadius: '5px',
                                                                                opacity: item?.createdBy?.profilePicture ? 1 : 0.3,

                                                                            }} className="rounded-circle" />
                                                                        <div>
                                                                            <div className='fw-medium fs-6'>{item?.Lead_Owner?.name ?? '-'}</div>
                                                                            <div className='text-secondary'>{item?.updatedAt ? formatDateTime(item?.updatedAt) : '-'}</div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {transformedDeals?.length === 0 && (
                                                            <tr>
                                                                <td colSpan={3} className="text-center py-4">No data found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {formsubmodules?.isPagination && (
                                                <Pagination
                                                    className="ag-theme-quartz"
                                                    currentPage={currentPage}
                                                    pageSize={pageSize}
                                                    totalCount={formsubmodules?.totalCount}
                                                    onPageSizeChange={handlePageSizeChange}
                                                    onPrevPage={handlePrevPage}
                                                    onNextPage={handleNextPage}
                                                />
                                            )}
                                        </div>
                                    </>)}
                                    {canvasView === 'kanban' && formsubmodules?.modules?.name === "Deals" && (<>
                                        <div className='kanban-view mt-2 vstack bg-body-secondary'
                                            style={{ height: 'calc(100vh - 150px)' }}>
                                            <KanbanBoard
                                                id={id}
                                                stageProbability={stageProbability}
                                                createAssignmentData={createAssignmentData}
                                                setOwnerChangeModal={setOwnerChangeModal}
                                                setSendEmail={setSendEmail}
                                                setSelectedRowData={setSelectedRowData}
                                                basicPermissionData={basicPermissionData}
                                                setPermissionDenied={setPermissionDenied}
                                                setRemoveModalData={setRemoveModalData} />
                                        </div>
                                    </>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {openImportModal && <ImportModal show={openImportModal} handleClose={() => setOpenImportModal(false)} moduleId={id} />}
            {removeModalData && (<ConfirmationModal data={removeModalData} show={true} handleClose={() => setRemoveModalData(null)} handleSuccess={(subModuleId) => {
                removeData({ subModuleId: removeModalData.subModuleId, payload: { moduleId: removeModalData.payload.moduleId } });
                setRemoveModalData(null);
            }}
            />)}
            {showManageColumn && <ManageColumn show={showManageColumn} handleClose={() => setShowManageColumn(null)} getValue={dynamicTableHeader} setValue={setDynamicTableHeader} data={{ moduleId: id, tableColumnId: formsubmodules?.tableColumns?._id }} createApi={createTableColumnSubFormModuleStart} updateApi={updateTableColumnSubFormModuleStart} />}
            {showPreviewModalId !== null &&
                <PreviewModal show={showPreviewModalId !== null} preview={true}
                    moduleStoreData={formsubmodules?.modules?.fields}
                    handleClose={() => {
                        setShowPreviewModalId(null)
                        dispatch(destroyModuleLog());
                    }}
                    storeData={getFormsubmodule(showPreviewModalId) || {}}
                    setStoreData={setStoreData}
                    subFormId={showPreviewModalId} moduleId={id}
                    stageProbability={stageProbability}
                    DealName={DealName}
                />
            }
            {permissionDenied && <PermissionDeniedModal />}
            {(selectedSubformId && taskModuleData) && <CreateAssignment show={true} handleClose={() => {
                setSeletedSubFormId(null);
                setTaskModuleData(null);
            }} moduleData={taskModuleData} subFormId={selectedSubformId} basedModuleId={id} basedSubFormData={getFormsubmodule(selectedSubformId) || {}} basedModuleStoreData={formsubmodules?.modules} />}
            {ownerChangeModal && <OwnerChange show={!!ownerChangeModal} handleClose={() => {
                setOwnerChangeModal(null);
            }} basedModuleStoreData={formsubmodules?.modules} basedSubFormData={getFormsubmodule(ownerChangeModal) || {}} />}
            {sendEmail &&
                <EmailComposer
                    sendEmail={sendEmail}
                    setSendEmail={setSendEmail}
                    id={id}
                    selectedRowData={selectedRowData}
                    moduleName={formsubmodules?.modules?.name}
                />
            }
            {showPrintExportQuoteModal &&
                <ExportQuotePdf
                    showPrintExportModal={showPrintExportQuoteModal}
                    setShowPrintExportModal={setShowPrintExportQuoteModal}
                    templateData={templateData}
                    selectedRowData={selectedRowData}
                    printExportModalTitle={printExportModalTitle}
                    selectedModule={formsubmodules?.modules?.name}
                    rowData={getFormsubmodule(showExportModalId)}
                    id={id}
                    selectedRowTableData={selectedRowTableData}
                />
            }
            {showPrintExportSoModal &&
                <ExportSoPdf
                    showPrintExportModal={showPrintExportSoModal}
                    setShowPrintExportModal={setShowPrintExportSoModal}
                    templateData={templateData}
                    selectedRowData={selectedRowData}
                    printExportModalTitle={printExportModalTitle}
                    selectedModule={formsubmodules?.modules?.name}
                    rowData={getFormsubmodule(showExportModalId)}
                    id={id}
                    selectedRowTableData={selectedRowTableData}
                />
            }
            {showPrintExportInvModal &&
                <ExportInvPdf
                    showPrintExportModal={showPrintExportInvModal}
                    setShowPrintExportModal={setShowPrintExportInvModal}
                    // templateData={templateData?.data}
                    selectedRowData={selectedRowData}
                    printExportModalTitle={printExportModalTitle}
                    selectedModule={formsubmodules?.modules?.name}
                    rowData={getFormsubmodule(showExportModalId)}
                    id={id}
                    selectedRowTableData={selectedRowTableData}
                />
            }
            {showAiConfirmationModal &&
                <AiConformationModal
                    showAiConfirmationModal={showAiConfirmationModal}
                    setShowAiConfirmationModal={setShowAiConfirmationModal}
                    setIsResponseGenerated={setIsResponseGenerated}
                    type="Generate"
                />
            }
            {/* {showAiResponseModal &&
                <AiResponse
                    showAiResponseModal={showAiResponseModal}
                    setShowAiResponseModal={setShowAiResponseModal}
                    generatedData={promptData.generatedData}
                    id={id}
                    selectedRowDataToGnerate={selectedRowDataToGnerate}
                    currentUserData={currentUserData}
                />
            } */}
            {showAiResponseModal &&
                <ResearchContent
                    showAiResponseModal={showAiResponseModal}
                    setShowAiResponseModal={setShowAiResponseModal}
                    selectedRowAiResponse={selectedRowAiResponse}
                    id={id}
                    selectedRowDataToReGnerate={selectedRowDataToReGnerate}
                    currentUserData={currentUserData}
                    moduleName={formsubmodules?.modules?.name}
                    rowAllData={rowAllData}
                />
            }

            {showEmailModal &&
                <Emails
                    showEmailModal={showEmailModal}
                    setShowEmailModal={setShowEmailModal}
                    selectedRowDataToViewMail={selectedRowDataToViewMail}
                    formsubmodules={formsubmodules?.modules?.name}
                />
            }
            {showComposeEmailModal &&
                <ComposeMail
                    showComposeEmailModal={showComposeEmailModal}
                    setShowComposeEmailModal={setShowComposeEmailModal}
                />
            }
        </>
    );
};

export default SubModule;